import React, { useEffect, useMemo, useState } from "react";
import { Settings } from "lucide-react";
import { NavLink, useLocation } from "react-router-dom";
import { getAllItems } from "../../../../config/services/ManualTransactionService";
import PendingEntries from "../channelInvestigate/investigateTabs/PendingEntries";

/** =====================
 * TYPES
 ====================== */
export interface DisplayTransaction {
  manual_txn_id: number;
  accountNumber: string;
  reference_number: string;
  txn_date: string;
  rrn?: string;
  date?: string;
  amount?: number;
  channelId: string;
  sourceId: string;
  json_file: Record<string, any>;
}

/** =====================
 * NORMALIZER
 ====================== */
const normalizeTxn = (item: any): DisplayTransaction => {
  const jf = item.json_file || {};

  return {
    manual_txn_id: item.manual_txn_id,
    amount: item.amount ?? 0,
    accountNumber: item.account_number,
    reference_number: item.reference_number,
    txn_date: item.txn_date,
    rrn: jf.reference_number || item.reference_number,
    date: jf.txn_date,
    channelId: item.channel_id,
    sourceId: item.source_id,
    json_file: jf,  
  };
};

const AccountInvestigate = () => {
  const location = useLocation();
  const [date, setDate] = useState(new Date().toLocaleDateString('en-CA'));
  const [activeTab, setActiveTab] = useState("Not Matched");
  const [journalTransactions, setJournalTransactions] = useState<any[]>([]);
  const [rawTxns, setRawTxns] = useState<DisplayTransaction[]>([]);
const [selectedAccount, setselectedAccount] = useState<string | null>(null);
const [selectedDate, setSelectedDate] = useState<string | null>(null);

const fetchTransactions = async () => {
    try {
      const resp = await getAllItems();
      setRawTxns(resp.map(normalizeTxn));
    } catch (err) {
      console.error("Failed to fetch transactions", err);
    }
  };

  useEffect(() => {
    fetchTransactions();
  }, []);

useEffect(()=>{
  if(rawTxns.length>0 && rawTxns[0]?.date){
    const filteredDate = new Date (rawTxns[0]?.date).toLocaleDateString('en-CA');
    setDate(filteredDate);
  }
},[rawTxns])

// Searching for Channel ID
const availableChannels = useMemo(() => {
  return Array.from(
    new Set(rawTxns.map(txn => txn.channelId))
  );
}, [rawTxns]);

  return (
    <div className="flex flex-col bg-gray-50 min-h-screen">
      {/* HEADER */}
      <div className="bg-white border-b px-6 py-3 flex items-center justify-between">
        <h2 className="text-2xl font-bold text-gray-900">Account Investigation - {selectedAccount ?? ""}</h2>

        {/* <div className="mb-4 flex items-center gap-3">
  <label className="text-sm font-medium text-gray-600">
    Channel:
  </label>

  <select
  value={selectedAccount ?? ""}
  onChange={e => setselectedAccount(e.target.value)}
  className="border border-gray-300 rounded px-3 py-1 text-sm"
>
  {availableChannels.map(ch => (
    <option key={ch} value={ch}>
      {ch}
    </option>
  ))}
</select>

</div> */}
<div className="mb-4 flex items-center gap-6">
  {/* Channel */}
  <div className="flex items-center gap-3">
    <label className="text-sm font-medium text-gray-600">Account:</label>
    <select
    //   value={selectedAccount ?? ""}
    //   onChange={e => setselectedAccount(e.target.value)}
      className="border border-gray-300 rounded px-3 py-1 text-sm"
    >
      {/* {availableChannels.map(ch => (
        <option key={ch} value={ch}>{ch}</option>
      ))} */}
    </select>
  </div>

  {/* Date */}
  <div className="flex items-center gap-3">
    <label className="text-sm font-medium text-gray-600">Date:</label>
    <input
      type="date"
      value={date ?? ""}
      onChange={e => setSelectedDate(e.target.value)}
      className="border border-gray-300 rounded px-3 py-1 text-sm"
    />
  </div>
</div>
 
        {/* <NavLink to="/quick-matching-rule">
          <button className="px-4 py-2 bg-gray-600 text-white rounded text-sm flex items-center gap-2">
            <Settings size={16} /> Matching Rules
          </button>
        </NavLink> */}
      </div>

      {/* TABS */}
      <div className="bg-white border-b px-6 flex gap-1">
       {["Not Matched", "Journal Entries", "Pending Entries"].map(tab => (
          <button
            key={tab}
            onClick={() => setActiveTab(tab)}
            className={`px-4 py-2.5 text-sm font-medium border-b-2 ${
              activeTab === tab
                ? "text-blue-600 border-blue-600"
                : "text-gray-600"
            }`}
          >
            {tab}
          </button>
        ))}
      </div>

      {/* CONTENT */}
      

      {/* <div className="flex-1 p-4 overflow-auto">
        {activeTab === "Not Matched" && (
          <ToMatchTab
            data={groupedTxns}
            onCreateJournal={handleCreateJournal}
            fetchTransactions= {fetchTransactions}
          />
        )}

        {activeTab === "Journal Entries" && (
          <JournalEntries
            transactions={journalTransactions}
            matchingMode="3way"
            onJournalPosted={handleJournalPosted}
          />
        )}
      </div> */}
      {activeTab === "Pending Entries" &&(
          <PendingEntries/>
        )}
    </div>
  );
};

export default AccountInvestigate;
